export const paths = {
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  dashboard: '/dashboard',
  users: '/users',
  clients: '/clients',
  clientDetails: '/clients/:clientId',
  projectClients: '/project-clients',
  partners: '/partners',
  pricingPackages: '/pricing-packages',
  priceCatalog: '/preiskatalog',
  /** Optional category segment — one mounted page keeps selections alive across switches. */
  priceCatalogCategory: '/preiskatalog/:categoryId?',
  /** Door templates per room type: what a new door card starts from. */
  doorTemplates: '/vorlagen',
  /** The company's rules in its own words, which the Tür-Agent applies. */
  doorRules: '/regeln',
  projectClientProjects: '/project-clients/:projectClientId/projects',
  /** The project route IS the plan: redirects to the latest evaluation's canvas, or shows the upload hero. */
  projectWorkspace: '/project-clients/:projectClientId/projects/:projectId',
  projectWorkspaceEvaluationPlan:
    '/project-clients/:projectClientId/projects/:projectId/evaluations/:evaluationId/plan',
  evaluationPlan: '/projects/:projectId/evaluations/:evaluationId/plan',
  projectWorkspaceEvaluationOffer:
    '/project-clients/:projectClientId/projects/:projectId/evaluations/:evaluationId/offerte',
  evaluationOffer: '/projects/:projectId/evaluations/:evaluationId/offerte',
  profile: '/profile',
  forbidden: '/forbidden',
} as const;

/** Resolved evaluation offer URL. Prefer `projectClientId` when known so the URL matches the project hierarchy. */
export function evaluationOfferPath(
  projectId: string,
  evaluationId: string,
  projectClientId?: string,
): string {
  return projectClientId
    ? paths.projectWorkspaceEvaluationOffer
        .replace(':projectClientId', projectClientId)
        .replace(':projectId', projectId)
        .replace(':evaluationId', evaluationId)
    : paths.evaluationOffer
        .replace(':projectId', projectId)
        .replace(':evaluationId', evaluationId);
}

/** Resolved projects-list URL for a project client. */
export function projectClientProjectsPath(projectClientId: string): string {
  return paths.projectClientProjects.replace(':projectClientId', projectClientId);
}

/** Resolved evaluation plan URL. Prefer `projectClientId` when known so the URL matches the project hierarchy. */
export function evaluationPlanPath(
  projectId: string,
  evaluationId: string,
  projectClientId?: string,
): string {
  return projectClientId
    ? paths.projectWorkspaceEvaluationPlan
        .replace(':projectClientId', projectClientId)
        .replace(':projectId', projectId)
        .replace(':evaluationId', evaluationId)
    : paths.evaluationPlan.replace(':projectId', projectId).replace(':evaluationId', evaluationId);
}

export type AppPath = (typeof paths)[keyof typeof paths];
